<template>
    <div class="becrop__loader__wrapper" :style="{'height': this.dim + 'px', 'width': this.dim + 'px'}">
        <div class="becrop__loader" :style="{'height': this.dim + 'px', 'width': this.dim + 'px'}">
            <div class="semicircle" :style="{'-webkit-border-radius': '0 0 ' + this.dim + 'px ' + this.dim + 'px', 'border-radius': '0 0 ' + this.dim + 'px ' + this.dim + 'px'}">
            </div>
        </div>

        <div class="becrop__line__loader" :style="{'height': this.dim + 'px', 'width': this.dim + 'px'}">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve" :style="{'height': this.dim + 'px', 'width': this.dim + 'px'}">
                <line class="first" x1="42.7" y1="7.3" x2="7.3" y2="42.7"></line>
                <line class="second" x1="42.7" y1="7.3" x2="7.3" y2="42.7"></line>
            </svg>
        </div>
    </div>
</template>

<style lang="scss" scoped >

</style>


<script>
    export default {

        props: [
            'dim'
        ],

        data(){
            return {
                optSel: this.def
            };
        },

        components: {

        },

        methods: {
            onChange() {
                this.$emit('onselectchange', this.optSel);
            }
        }
    }

</script>